"use strict";

/*
* ***********************************Example of Usage***********************************
*
* 1 - Simple usage
*    var options = [
*       {value: 0, checked: true, text: "Tarefas"},
*       {value: 1, checked: false, text: "Tarefas + detalhes de Métricas"}];
*     <ExportButton onExport={this.props.onExport}
*       getExtraOptions={this.getExtraOptions}
*       options={options}
*       exportName="atividade" />
*
*/

var PromptConfirmButtonGroup = require("app/shared/components/Prompt/prompt-confirm-button-group");
var Button = require("app/shared/components/Button/button");
var Icon = require("app/shared/components/Icon/icon");

// Change the prompt to use the new one, you will have to change the tests too.
var PromptList = require("app/shared/components/Prompt/prompt-list");
var Prompt = require("app/shared/components/Prompt/prompt");
var SignalActions = require("app/shared/actions/signal-actions");

var ExportButton = React.createClass({
  propTypes: {
    onExport: React.PropTypes.func.isRequired,
    options: React.PropTypes.array.isRequired,
    exportName: React.PropTypes.string.isRequired,
    getExtraOptions: React.PropTypes.func,
    skipOptions: React.PropTypes.bool,
    buttonText: React.PropTypes.string
  },
  getDefaultProps: function() {
    return {
      skipOptions: false,
      buttonText: "Exportar"
    }
  },
  getInitialState: function() {
    return this.initialState();
  },
  initialState: function() {
    let defaultStatus = this.props.skipOptions ? "created" : null;

    return {
      exportStatus: defaultStatus,
      selectionValue: null,
      url: null
    };
  },
  handleExport: function(selection = null) {
    let selectionValue = this.state.selectionValue;

    if (selection) {
      selectionValue = Array.isArray(selection) && selection[0].value;
    }

    if (Number.isInteger(selectionValue) || this.props.skipOptions) {
      let extraOptions;
      if (this.props.getExtraOptions) {
        extraOptions = this.props.getExtraOptions(selectionValue);
      }

      $(document).one("Export.finished", this.exportFinish);

      this.props.onExport(this.props.exportName, true, extraOptions);

      this.setState({
        exportStatus: "created",
        selectionValue: selectionValue
      });
    } else {
      this.showSignal({ message:"Selecione uma opção para prosseguir." });
    }
  },
  exportFinish: function(event, data) {
    this.setState({
      exportStatus: data.status,
      url: data.url
    });
  },
  showSignal: function(params) {
    SignalActions.show({
      message: params.message,
      type: params.type || "warning",
      hideTimeout: params.hideTimeout || 5000
    });
  },
  getPrompt: function() {
    if (!this.state.exportStatus && !this.props.skipOptions) {
      return <PromptList selectionType="radioButton" title="Quais informações deseja visualizar na exportação?" buttonText="Exportar"
        checkboxItems={this.props.options}
        buttonAlwaysEnabled={true}
        autoClose={false}
        buttonClasses="btn btn-primary" type="confirm" onConfirm={this.handleExport}
      />
    } else {
      let promptProps = this.exportContent()[this.state.exportStatus];

      return <Prompt type={promptProps.type}
        title={promptProps.title}
        text={promptProps.text}
        buttonText={promptProps.buttonText}
        buttonClasses={promptProps.buttonClasses}
        onCancel={promptProps.cancelReset ? this.resetState : null}
        onConfirm={promptProps.onConfirm}
        autoClose={promptProps.autoClose}
        disabledConfirmButton={promptProps.disabledConfirmButton}>
          {promptProps.childProp}
      </Prompt>
    }
  },
  exportContent: function() {
    return {
      created: {
        type: "confirm",
        title: "Estamos realizando a sua exportação!",
        text: "Não feche esta mensagem. Em alguns instantes, sua exportação estará pronta.",
        buttonText: <span>Preparando Arquivo...</span>,
        buttonClasses: "btn btn-primary",
        disabledConfirmButton: true,
        childProp: <p className="fs-12 fst-i mt-10">Tempo estimado: 90 segundos</p>
      },
      finished: {
        type: "alert",
        title: "Sua exportação está pronta!",
        buttonText: <span>Baixar Arquivo</span>,
        buttonClasses: "btn btn-success",
        disabledConfirmButton: false,
        cancelReset: true,
        onConfirm: this.downloadFile,
        autoClose: true,
        childProp: <div style={{width: 465}}><div className="c-primaryGreen glyphicon glyphicon-ok fs-64"></div></div>
      },
      failed: {
        type: "alert",
        title: "Ops, não foi possível realizar sua exportação :(",
        text: "Tente novamente daqui alguns instantes!",
        buttonClasses: "btn btn-primary",
        cancelReset: true,
        onConfirm: this.retryExport,
        autoClose: false,
        buttonText: <span>Tentar Novamente</span>
      }
    }
  },
  resetState: function() {
    this.setState(this.initialState());
  },
  downloadFile: function() {
    window.open(this.state.url, "_blank");
    this.resetState();
  },
  retryExport: function() {
    this.handleExport(this.state.selectionValue);
  },
  promptAction: function() {
    if (this.props.skipOptions) {
      this.handleExport();
    }
  },
  render: function() {
    return <PromptConfirmButtonGroup showPromptAction={this.promptAction}>
      {this.getPrompt()}
      <Button type="gray" className="w-100pct">
        <span className="d-f">
          <Icon custom={true} icon="arrow-down" className="c-primaryBlue" />
          <span>{this.props.buttonText}</span>
        </span>
      </Button>
    </PromptConfirmButtonGroup>
  }
});

module.exports = ExportButton;



// WEBPACK FOOTER //
// ./app/shared/components/ExportButton/export-button.jsx